import { TFunction } from "i18next";
import { Span } from "src/components/base";
import { MAX_TOP_TRADERS_TO_DISPLAY } from "./constants";

const Comma = () => <Span ml={-0.5}>{","}</Span>;

interface IReactionsCountParams {
    index: number;
    totalResults: number;
    t: TFunction;
}

// This component enhances the top trader's reaction name by adding punctuation and a description at the end.

export const ReactionsCount = ({ index, totalResults, t }: IReactionsCountParams) => {
    switch (true) {
        // Single result case
        case totalResults === 1 && index === 0:
            return t("top-trader-reaction.has-already-responded");

        // Two results cases
        case totalResults === 2:
            return index === 0 ? t("top-trader-reaction.and") : t("top-trader-reaction.have-already-responded");

        // Three results cases
        case totalResults === 3:
            switch (index) {
                case 0:
                    return <Comma />;
                case 1:
                    return t("top-trader-reaction.and");
                case 2:
                    return t("top-trader-reaction.have-already-responded");
            }
            break;

        // Four results cases
        case totalResults === 4:
            if (index === 0 || index === 1) return <Comma />;
            if (index === 2) {
                return (
                    <>
                        {t("top-trader-reaction.and")} <strong>{t("top-trader-reaction.one-more-top-trader")}</strong>{" "}
                        {t("top-trader-reaction.top-traders-reacted-plural-end")}
                    </>
                );
            }
            break;

        // Five or more results cases
        case totalResults >= 5:
            if (index === 0 || index === 1) return <Comma />;
            if (index === 2) {
                return (
                    <>
                        {t("top-trader-reaction.and")}{" "}
                        <strong>
                            {t("top-trader-reaction.top-traders-reacted-plural-start", {
                                count: totalResults - MAX_TOP_TRADERS_TO_DISPLAY,
                            })}
                        </strong>{" "}
                        {t("top-trader-reaction.top-traders-reacted-plural-end")}
                    </>
                );
            }
            break;

        // Default case
        default:
            return "";
    }
};
